export default __webpack_public_path__ + "static/media/inComing.b9931cb2.ico";